"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMisc = exports.decodePPG = exports.decodeAccel = exports.decodeGyro = exports.decodeEEGSamples = exports.decodeEEG = exports.sendStimulation = exports.sendCommand = exports.write = void 0;
const constants_1 = require("./constants");
const ble_utils_1 = require("./ble-utils");
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const c = __importStar(require("./constants"));
async function write(deviceId, cmd) {
    return bluetooth_le_1.BleClient.writeWithoutResponse(deviceId, c.INSAI_SERVICE, c.INSAI_CONTROL_CHARACTERISTIC, cmd);
}
exports.write = write;
async function sendCommand(deviceId, status) {
    const startCommand = new Uint8Array([status, 255]);
    const view = new DataView(startCommand.buffer);
    await write(deviceId, view);
}
exports.sendCommand = sendCommand;
//programs are: 2,3,4,5
async function sendStimulation(deviceId, start, program = 2, voltage = 6, duration = 5) {
    const command = new Uint8Array([program, voltage, duration]);
    const view = start ? new DataView(command.buffer) : new DataView(new Uint8Array([0]).buffer);
    console.log('send command', view);
    await bluetooth_le_1.BleClient.writeWithoutResponse(deviceId, c.INSAI_SERVICE, c.INSAI_STIMULATION_CHARACTERISTIC, view);
}
exports.sendStimulation = sendStimulation;
function decodeEEG(samples) {
    const data = [];
    for (let channel = 0; channel < 8; channel += 1) {
        const channelData = [];
        for (let sample = 0; sample < 10; sample += 1) {
            channelData.push(samples[channel + sample * 8]);
        }
        data.push(channelData);
    }
    return data;
}
exports.decodeEEG = decodeEEG;
function decodeEEGSamples(samples, gain) {
    return decodeEEG(ble_utils_1.decodeInt24BitData(samples).map((n) => (n * constants_1.INSAI_EEG_SCALING_FACTOR_WITHOUT_GAIN) / (gain ? gain : 1)));
}
exports.decodeEEGSamples = decodeEEGSamples;
function decodeGyro(samples) {
    const data = [];
    for (let channel = 0; channel < 3; channel += 1) {
        const channelData = [];
        for (let sample = 0; sample < 5; sample += 1) {
            channelData.push(samples[channel + sample * 7]);
        }
        data.push(channelData);
    }
    return data;
}
exports.decodeGyro = decodeGyro;
function decodeAccel(samples) {
    const data = [];
    for (let channel = 3; channel < 6; channel += 1) {
        const channelData = [];
        for (let sample = 0; sample < 5; sample += 1) {
            channelData.push(samples[channel + sample * 7]);
        }
        data.push(channelData);
    }
    return data;
}
exports.decodeAccel = decodeAccel;
function decodePPG(samples) {
    const data = [];
    for (let channel = 6; channel < 7; channel += 1) {
        const channelData = [];
        for (let sample = 0; sample < 5; sample += 1) {
            channelData.push(samples[channel + sample * 7]);
        }
        data.push(channelData);
    }
    return data;
}
exports.decodePPG = decodePPG;
function decodeMisc(value) {
    const buffer = new Uint8Array(value.buffer);
    const index = ble_utils_1.decodeInt24BitData(buffer.slice(70, 73))[0];
    const samples = ble_utils_1.decodeUint16BitData(buffer.slice(0, 70));
    return { index, samples };
}
exports.decodeMisc = decodeMisc;
//# sourceMappingURL=nexus-utils.js.map